import { put, get, post } from '../request'

export const createApplication = (data) => post('api/application-items', { data })
export const updateApplicationItem = (application, data) => put(`api/application-items/${application}`, data)
export const addToApplication = (applicationItem, data) =>
  put(`api/application-items/add-to-application/${applicationItem}`, data)
export const removeFromApplication = (applicationItem, data) =>
  put(`api/application-items/remove-from-application/${applicationItem}`, data)
export const getApplicationItemsByProject = (ids, pagination, filter) =>
  get(`api/application-items/find/by/projects`, { ids, pagination, filter })
export const archiveApplicationItem = (applicationItem) => put(`api/application-items/archive/${applicationItem}`)
